export const zoneStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '30px 10px',
  borderWidth: 1,
  borderRadius: 4,
  borderColor: '#4a5568',
  borderStyle: 'dashed',
  backgroundColor: '#1e2533',
  color: '#e2e8f0',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  minHeight: '120px',
  maxWidth: '100%',
  justifyContent: 'center',
  boxSizing: 'border-box',
  margin: '0'
} as const;

export const rejectedFilesMessage = (path: string) => `El archivo ${path} no es compatible. Solo se permiten archivos Excel (.xlsx, .xls)`;